module.exports = __webpack_public_path__ + "static/media/auto-scroll.f1bc35a5.gif";